import { useAuthenticatedContext } from 'hooks/useAuthenticated';

import { redirectPaths } from './routes';

const useGetRedirectPath = () => {
  const { currentUser } = useAuthenticatedContext();
  return currentUser !== null ? redirectPaths[currentUser.company] : redirectPaths.loggedOut;
};

export default useGetRedirectPath;
